import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { buildAnimalSeoPage } from './animalExplorerSeo';
import './AnimalExplorerPublicPage.css';

export default function AnimalExplorerSeoPage({ kind }) {
  const params = useParams();
  const page = buildAnimalSeoPage(kind, params);
  React.useEffect(() => {
    if (!page) return undefined;
    const previous = document.title;
    document.title = `${page.title} | Animal Explorer`;
    return () => { document.title = previous; };
  }, [page]);
  if (!page) return <main className="ae-public ae-public__seo"><h1>Animal page not found</h1><Link to="/animal-explorer">Return to Animal Explorer</Link></main>;
  const schema = { '@context': 'https://schema.org', '@type': page.answer ? 'FAQPage' : 'WebPage', name: page.title, description: page.description };
  return <main className="ae-public ae-public__seo">
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
    <p className="ae-public__eyebrow">ANIMAL EXPLORER · SOURCED REFERENCE</p>
    <h1>{page.title}</h1>
    <p className="ae-public__lead">{page.answer || page.description}</p>
    <section className="ae-public__seo-grid">{page.taxa.map((taxon) => <article key={taxon.scientificName}><h2>{taxon.commonName}</h2><p><i>{taxon.scientificName}</i></p><p>{taxon.group}</p><small>Taxonomy source: {taxon.source}. Recheck the live product for release metadata and conflicts.</small></article>)}</section>
    <p>These public pages expose only reviewed, source-backed fields. They do not publish precise occurrence coordinates or infer missing traits.</p>
    <Link className="ae-public__primary" to="/animal-explorer">Explore the full product</Link>
  </main>;
}
